export default __webpack_public_path__ + "static/media/upload.f3981cb3.png";